import React, { Component } from "react";
import "./FormulaireInformations.scss";
import Modal from "react-bootstrap/Modal";
import { auth } from "../Authentication/Authentication";
import * as Storage from "../Authentication/Storage";
import { Link } from "react-router-dom";

export class FormulaireInformations extends Component {
	state = {
		messageModal: false
	};

	componentDidMount() {
		// const user = JSON.parse(localStorage.getItem("user"));
		const user = Storage.getUserParsed();

		console.table(user);

		!this.props.app.state.abonne &&
			this.props.app.setState({
				elements: {
					...this.props.app.state.elements,
					["nom"]: user.lastname,
					["user"]: user.id,
					["prenom"]: user.firstname,
					["email"]: user.email,
					["tel"]: user.telMobile || ""
				}
			});
	}

	handleChangeText = name => event => {
		this.props.app.setState(
			{
				elements: {
					...this.props.app.state.elements,
					[name]: event.target.value
				}
			},
			() => console.table(this.props.app.state.elements)
		);
		console.log("Valeur de : " + name + " -> " + event.target.value);
	};

	inputText(label, name, type, nbrCol) {
		return (
			<div className={"form-group col-md-" + nbrCol}>
				<label htmlFor="" className="col-form-label ">
					{label}
				</label>
				<input
					style={{ backgroundColor: "#f6f6f6", color: "#000" }}
					type={type}
					value={this.props.app.state.elements[name]}
					onChange={this.handleChangeText(name)}
					className="form-control"
					id={"Id" + name}
					placeholder={label + "*"}
					name={name + "Name"}
					required
				/>
			</div>
		);
	}

	inputTextReadOnly(label, name, type, nbrCol) {
		return (
			<div className={"form-group col-md-" + nbrCol}>
				<label htmlFor="" className="col-form-label ">
					{label}
				</label>
				<input
					style={{ backgroundColor: "#f6f6f6", color: "#000" }}
					type={type}
					value={this.props.app.state.elements[name]}
					className="form-control"
					id={"Id" + name}
					placeholder={label + "*"}
					name={name + "Name"}
					required
					readOnly
					disabled
				/>
			</div>
		);
	}

	inputNumber(label, name, type, nbrCol) {
		return (
			<div className={"form-group col-md-" + nbrCol}>
				<label htmlFor="" className="col-form-label ">
					{label}
				</label>
				<div className="input-group input-group-lg">
					<input
						type={type}
						value={this.props.app.state.elements[name]}
						onChange={this.handleChangeText(name)}
						className="form-control text-center montantDonInput"
						id={"Id" + name}
						name={name + "Name"}
						required
					/>
					<span className="input-group-addon euro"> €</span>
				</div>
			</div>
		);
	}

	handleChange = event => {
		console.log(event);
		let target = event.target;
		let value = target.value;
		let id = target.id;
		console.log(event.target.checked);
		console.log(value);
		console.log(id);
	};

	handleSubmitFormulaire = event => {
		event.preventDefault();
		auth.userHaveAuthorities(["ROLE_CONNECTED"])
			? this.props.app.setState({ tabFormulaire: 3 }, () => {
					sessionStorage.setItem("tabFormulaire", 3);
					console.log(this.props.app.state.elements);
			  })
			: this.props.history.push({
					pathname: "/login",
					state: { from: "/revue" }
			  });
	};

	render() {
		const BoiteDialogue = () => (
			<Modal
				show={this.state.showModal}
				onHide={() =>
					this.setState({ showModal: false }, () =>
						this.props.reloadPage ? null : window.location.reload()
					)
				}
			>
				<Modal.Body>
					<button
						type="button"
						class="close"
						data-dismiss="modal"
						aria-label="Close"
						onClick={() => this.setState({ showModal: false })}
					>
						<span aria-hidden="true">&times;</span>
					</button>
					<h4 className="text-center">Veuillez remplir tous les champs !</h4>
				</Modal.Body>
			</Modal>
		);
		return (
			<div className="formulaireInformations">
				<form onSubmit={this.handleSubmitFormulaire} method="POST">
					{/* <form> */}
					<div
						className="text-center"
						style={{ fontSize: "1.1rem", fontWeight: "bold" }}
					>
						<b>Informations du compte</b>
					</div>
					<div className="text-center" style={{ fontSize: "0.8rem" }}>
						ces données peuvent être modifiés dans l'espace{" "}
						<Link to="/mon-compte">mom-compte</Link>
					</div>
					<div className="form-row">
						{this.inputTextReadOnly("Nom (compte)", "nom", "text", "6")}
						{this.inputTextReadOnly("Prénom (compte)", "prenom", "text", "6")}
					</div>
					<div className="form-row">
						{this.inputTextReadOnly("Email (compte)", "email", "email", "6")}
						{this.inputText("Tel mobile", "tel", "tel", "6")}
					</div>
					<hr />
					<div className="form-row">
						{this.inputText("Adresse postale", "adressePostale", "text", "12")}
					</div>
					<div className="form-row">
						{this.inputText("Code postal", "codePostal", "text", "2")}
						{this.inputText("Ville", "ville", "text", "6")}
						{this.inputText("Pays", "pays", "text", "4")}
					</div>

					<div className="text-right pt-2">
						<button
							type="submit"
							// onClick={this.handleSubmitFormulaire}
							className="btn btn-primary center-block pl-5 pr-5"
						>
							Suivant
						</button>
					</div>
				</form>
				<BoiteDialogue />
			</div>
		);
	}
}
